<template>
  <!--
  * Copyright (c) 2014-2020 Zuoyebang, All rights reseved.
  * @fileoverview 邀请拉新+分享闭环端外页面
  * @author zhaoxinran | zhaoxinran@zuoyebang.com
  * @version 1.0 | 2020-01-06 | zhaoxinran   // 初始版本
  -->
  <div v-log:once="`name=KD_C31_1_1`" class="invitenewweb">
    <section v-if="os === 1" class="invite-window os-1">
      <div class="invite-logo"></div>
      <h2 class="invite-title">快对作业</h2>
      <p class="invite-content">
        恭喜获得
        <br />
        <span class="highlight">?</span>
        元话费
      </p>
      <p class="copy-tip">下载app后，点击按钮复制邀请码进入app即可</p>
      <div v-log-click="`KD_C31_1_2`" class="btn-copy" @click="handlerCopy">复制邀请码去APP提现</div>
      <p class="invite-tip">必得1元</p>
    </section>
    <section v-else class="invite-window os-0">
      <div class="invite-logo"></div>
      <h2 class="invite-title">快对作业</h2>
      <p class="invite-content">
        恭喜获得
        <br />
        <span class="highlight">?</span>
        元话费
      </p>
      <div v-log-click="`KD_C31_1_2`" class="btn-copy" @click="handlerCopy">去APP提现</div>
      <p class="invite-tip">必得1元</p>
    </section>
  </div>
</template>

<script>
import Clipboard from '@w/utils/clipboard';
import InvokeApp from '@w/utils/invokeApp';
import { toast } from '@w/utils/common';
export default {
  name: 'InviteNewWeb',
  data() {
    return {};
  },
  computed: {
    os() {
      return JSON.parse(this.$route.query.os);
    },
    shareCode() {
      return `^${decodeURIComponent(this.$route.query.link)}$`;
    }
  },
  methods: {
    handlerCopy() {
      const _ = this;
      /* eslint-disable no-new */
      new Clipboard({
        text: this.shareCode, // 需要复制的数据，
        successCallback() {
          if (_.os === 1) {
            toast('复制成功！\n进入App后页面需加载，请稍候～');
          } else {
            toast('进入App后页面需加载，请稍候～');
            /* eslint-disable no-new */
            const nativeLink = `kwzy://com.kuaiduizuoye.scan/main/invite/activity`;
            const invoker = new InvokeApp({
              downloadLink:
                'https://www.kuaiduizuoye.com/codesearch/download/apk?channel=other1_20180416&name=com_kuaiduizuoye_scan', // APP下载链接 必须
              yybLink: 'https://itunes.apple.com/cn/app/kuai-dui-zuo-ye/id1330927814?mt=8', // 应用宝的链接(weixin) 必须
              nativeLinkIos: nativeLink, // 唤起ios app
              nativeLinkAndroid: nativeLink, // 唤起andriod app
              universalLink: `//static.kuaiduizuoye.com/product/FECommon/Html/download/download.html?page=${encodeURIComponent(
                'showhomepage'
              )}` // ios9及以上唤起app跳转首页
            });
            invoker.active(); // 唤起app
          }
        },
        failureCallback() {
          // 失败的回调函数
        },
        errorCallback() {
          // 错误的回调函数
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../../assets/base');
.invitenewweb {
  .block-setting(100%, 100%, #000);
  overflow: scroll;
  .invite-window {
    padding-top: 290px;
    .block-setting(618px, 1020px, url(./resource/bg-page-web.png) center / 100% no-repeat);
    .center-middle-setting;
    transform: translate(-50%, -55%);
    .invite-logo {
      .block-setting(80px, 80px, url(../../assets/images/logo.png) center / 100% no-repeat);
      margin: 0 auto;
    }
    .invite-title {
      .font-setting(#fff, 30px, 60px, center);
    }
    .invite-content {
      .font-setting(#fff, 44px, 60px, center);
      .highlight {
        display: inline-block;
        .block-setting(52px, 52px);
        border: #fff000 1px solid;
        .font-setting(#FFF000, 44px, 52px, center, bold);
        margin: 0 10px;
      }
    }
    .copy-tip {
      .font-setting(#fff, 24px, 90px, center);
      margin: 50px auto 0;
    }
    .btn-copy {
      .block-setting(400px, 80px, #fff000, 40px);
      .font-setting(#333333, 30px, 80px, center, 600);
      .center-setting;
      bottom: 150px;
    }
    .invite-tip {
      .font-setting(#fff, 24px, 36px, center);
      .center-setting;
      bottom: 100px;
    }
    &.os-1 {
      .invite-content {
        margin-top: 50px;
      }
    }
    &.os-0 {
      .invite-content {
        margin-top: 100px;
      }
      .btn-copy {
        width: 300px;
      }
    }
  }
}
</style>
